import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Menu, X } from 'lucide-react'
import { DesktopNav } from './DesktopNav'
import { MobileNav } from './MobileNav'
import { ThemeToggle } from '../../ui/ThemeToggle'
import { useTheme } from '../../../contexts/ThemeContext'
import { getPersonalInfo } from '../../../config/configLoader'

export const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { isDark } = useTheme()
  const personalInfo = getPersonalInfo()
  const brandName = personalInfo?.name || 'Portfolio'

  return (
    <nav className={`
      fixed top-0 w-full z-50 transition-all duration-300
      ${isDark 
        ? 'glass-futuristic' 
        : 'glass-futuristic-light'
      }
    `}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <motion.div 
          initial={{ opacity: 0, x: -20 }} 
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.4, type: 'spring', stiffness: 200 }}
        >
          <Link to="/" className="flex items-center gap-2 group">
            <motion.span 
              className="w-2 h-2 rounded-full bg-accent-500"
              animate={{ scale: [1, 1.3, 1] }}
              transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
            />
            <span className={`
              text-sm font-semibold tracking-tight transition-colors
              ${isDark ? 'text-neutral-100' : 'text-neutral-900'}
              group-hover:text-accent-500
            `}>
              {brandName}
            </span>
          </Link>
        </motion.div>

        <motion.div 
          className="flex items-center gap-3"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.4, delay: 0.1, type: 'spring', stiffness: 200 }}
        >
          <DesktopNav />
          <ThemeToggle className="hidden md:block" />
          <button 
            className={`
              md:hidden p-2 rounded-lg transition-colors
              ${isDark ? 'hover:bg-neutral-800 text-neutral-400' : 'hover:bg-neutral-100 text-neutral-600'}
            `}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </motion.div>
      </div>

      <MobileNav isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
    </nav>
  )
}